import { render } from "./EeiaGenerality.vue?vue&type=template&id=2b16a00b&scoped=true"
import script from "./EeiaGenerality.vue?vue&type=script&lang=js"
export * from "./EeiaGenerality.vue?vue&type=script&lang=js"

import "./EeiaGenerality.vue?vue&type=style&index=0&id=2b16a00b&scoped=true&lang=css"

import exportComponent from "/var/www/html/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b16a00b"]])

export default __exports__